import { render, staticRenderFns } from "./jpRcvInfo.vue?vue&type=template&id=04fe11cc"
import script from "./jpRcvInfo.vue?vue&type=script&lang=js"
export * from "./jpRcvInfo.vue?vue&type=script&lang=js"
import style0 from "./jpRcvInfo.vue?vue&type=style&index=0&id=04fe11cc&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports